export class WFEDeleteWorkflowParametersDto {
    workflowId: number;
    communityId: number;
    workflowStatus: string; // NOTE: Required for most endpoints of workflow editor except for getting data entry editor
    deleteReason: string; // NOTE: Minimum three characters required
}
